export default __webpack_public_path__ + "static/media/transfer.1d6b4c13.svg";